import {Component, EventEmitter, Input, Output} from '@angular/core';
import {CommonModule} from "@angular/common";
import {FormGroup, FormsModule, ReactiveFormsModule} from "@angular/forms";
import {DateFormater} from "../../../../services/DateFormatter.service";
import {SnackBarService} from "../../../../services/snack-bar.service";
import {ManageTaxStrategiesServices} from "../../../../tpiq-services/manage-tax-strategies.service";
import {QuestionnairesSurveysService} from "../../../../services/questionnaires-surveys.service";
import {QuestionBase} from "../question-base/question-base";
import {ErrorHandlerService} from "../../../../services/error-handler.service";
import {Session} from "../../../../services/Session";
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCardModule } from '@angular/material/card';
import { MatRadioModule } from "@angular/material/radio";
import { TpiqFileUploadComponent } from "../../../../tpiq-file-upload/tpiq-file-upload.component"


declare const _: any;
declare const moment: any;

@Component({
  selector: 'app-dynamic-form-question',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, MatIconModule, MatCardModule,MatProgressSpinnerModule,MatTooltipModule,MatRadioModule,TpiqFileUploadComponent],
  templateUrl: './dynamic-form-question.component.html',
  styleUrl: './dynamic-form-question.component.scss'
})
export class DynamicFormQuestionComponent {
  @Input() question!: QuestionBase<string>;
  @Input() questionIndex: number;
  @Input() form!: FormGroup;
  @Input() userId: string;
  @Input() org: string;
  @Input() clientId: string;
  @Input() questionnaireId: string;
  @Input() questionnaireName: string;
  @Input() questionnaireBucket: string;
  @Input() s3Credentials: any;
  @Input() uploadBucket: string;
  @Input() lock: boolean;
  @Input() isCustomer: boolean;
  user: any;
  loader: boolean;
  commentData = '';
  postMessage = '';
  showComments = false;
  @Output() hideChat: EventEmitter<any> = new EventEmitter<any>();

  constructor(
   // private documentsService: DocumentService,
    private qsService: QuestionnairesSurveysService,
    private errorHandler: ErrorHandlerService,
    public snackBar: SnackBarService,
    private dateFormater: DateFormater,
    private taxStrategyServices: ManageTaxStrategiesServices,
  ) {
    this.user = Session.getUser();
  }

  get isValid(): any {
    return this.form.controls[this.question.key].valid;
  }

  get isRadioValid(): any {
    if (this.form.controls[this.question.key].value !== '') {
      return this.form.controls[this.question.key].valid;
    }
    return false;
  }

  get validCheckboxes(): any {
    let validate = false;
    _.forEach(this.form.get(this.question.key).value, (check) => {
      if (check) {
        validate = true;
      }
    });
    return validate;
  }

  get checkBoxUntouched(): any {
    let validate = false;
    _.forEach(((this.form.controls[this.question.key]) as FormGroup).controls, (control) => {
      if (control.touched) {
        validate = true;
      }
    });
    return validate;
  }

  get isTouched(): any {
    return this.form.controls[this.question.key].touched;
  }

  setRating(rating): void {
    this.form.controls[this.question.key].patchValue(rating);
  }

  get checkValid(): string {
    let control = '';
    if (this.question.mandatory) {
      if (this.question.type === 'Check Boxes' && !this.validCheckboxes && this.checkBoxUntouched) {
        control = 'invalid-control';
      } else if (this.question.type === 'Rating' && !this.isValid && this.isTouched) {
        control = 'invalid-control';
      } else if (!this.isValid && this.isTouched) {
        control = 'invalid-control';
      }
    }
    return control;
  }

  showChatBox(): void {
    this.hideChat.emit(this.question);
  }

  updateDocDetails(uploadedDocs): void {
    let uploadedFiles = [];
    _.forEach(uploadedDocs, (file) => {
      const docData = {
        documentID: file.id,
        documentName: file.name,
        questionID: file.sourceId,
        user: this.userId,
        bucket: this.uploadBucket,
        questionnaireBucket: this.questionnaireBucket
      };
      uploadedFiles = [...uploadedFiles, docData];
    });
    this.question.attachments = this.question.attachments.concat(uploadedFiles);
    // For saving document for Tax Questions
    this.qsService.uploadDocument(this.org, this.userId, 'clients', this.clientId, this.question.questionId, uploadedFiles)
      .subscribe(document => {
        this.snackBar.showNotification(`Uploaded Successfully`, 'success');
      }, error => {
        this.handleError(error);
      });
  }

  deleteFile(index, file): void {
    this.qsService.deleteDocument(this.org, this.userId, 'clients', this.clientId, this.question.questionId, file.documentID)
      .subscribe(document => {
        this.snackBar.showNotification(`Deleted Successfully`, 'success');
        this.question.attachments.splice(index, 1);
      }, error => {
        this.question.attachments.splice(index, 0, file);
        this.handleError(error);
      });
  }

  downloadDocument(attachment, type): void {
    this.taxStrategyServices.downloadDocument(this.userId, this.org, attachment.documentID)
      .subscribe(response => {
        window.open(response.temporaryURL);
      }, error => {
        this.handleError(error);
      });

    /*
            this.documentsService
                .processAttachedFile(attachment.documentID, attachment.documentName)
                .subscribe(
                    response => {
                        if (type === 'download') {
                            window.open(response.download_url, '_blank');
                        } else {
                            let link = response.preview_url;
                            if (
                                attachment.name.indexOf('.pdf') !== -1 ||
                                attachment.name.indexOf('.docx') !== -1
                            ) {
                                link =
                                    'https://drive.google.com/viewerng/viewer?url=' +
                                    encodeURIComponent(link);
                            }
                            window.open(link, '_blank');
                        }
                    },
                    error => {
                        this.handleError(error);
                    }
                );
    */
  }

  getPostObj(): any {
    return {
      user: {
        firstName: this.user.first_name,
        lastName: this.user.last_name,
        id: this.userId,
        colorCode: this.user.colorCode,
        bot: false,
        badgeName: `${this.user.first_name.charAt(0)}${this.user.last_name.charAt(0)}`
      },
      commentedBy: this.userId,
      commentMessage: this.postMessage,
      commentMessageHtml: this.postMessage,
      postID: '',
      browserTimeZone: '',
      commentId: '',
      question: this.question.question,
      questionNo: this.question.questionNo,
      questionnaireName: this.questionnaireName
    };
  }

  onPost(): void {
    this.loader = true;
    const obj = this.getPostObj();
    this.qsService.createPostMessage(this.org, this.userId, 'clients', this.clientId, this.question.questionId, obj)
      .subscribe((response) => {
        this.loader = false;
        this.postMessage = '';
        response.createdDate = this.updateDateTimeStamp(response.createdDate);
        this.question.comments.push(response);
        this.snackBar.showNotification('Posted Successfully', 'success');
      }, error => {
        this.handleError(error);
      });
  }

  editComment(index): void {
    this.question.comments[index]['editComment'] = true;
  }

  updateComment(index): void {
    this.question.comments[index]['editComment'] = false;
    const obj = this.question.comments[index];
    obj['commentMessageHtml'] = obj['commentMessage'];
    this.qsService.updatePostMessage(this.org, this.userId, 'clients', this.clientId, this.question.questionId, obj['commentId'], obj)
      .subscribe((response) => {
        this.loader = false;
        this.postMessage = '';
        // The update endpoint returns a {status, message} envelope, not the
        // comment. obj is the same array element, already edited in place, so
        // binding the response here would replace the comment with the envelope
        // and blank the text and author until reload.
        this.snackBar.showNotification('Updated Successfully', 'success');
      }, error => {
        this.handleError(error);
      });
  }

  closeUpdateComment(index): void {
    this.question.comments[index]['editComment'] = false;
  }

  updateDateTimeStamp(date): any {
    const serviceFormat = 'YYYY-MM-DD HH:mm:ss';
    const dateFormat = 'Do MMM, YYYY HH:mm';
    const startTime = moment.utc(date).toDate();
    return this.dateFormater.formatDate(startTime, serviceFormat, dateFormat);
  }

  onCancelPost(): void {
    this.postMessage = '';
  }

  deleteComment(index): void {
    const obj = this.question.comments[index];
    this.question.comments.splice(index, 1);
    this.qsService.deleteMessage(this.org, this.userId, 'clients', this.clientId, this.question.questionId, obj['commentId'])
      .subscribe((response) => {
        this.snackBar.showNotification('Deleted Successfully', 'success');
      }, error => {
        this.question.comments.splice(index, 0, obj);
        this.handleError(error);
      });
  }

  handleError(error): void {
    this.loader = false;
    this.errorHandler.handleError(error);
  }

}
